
import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiLinkedin, FiTwitter, FiSettings } = FiIcons;

const Footer = () => {
  // INSIGHTS_ENABLED: Set to true to show Insights in footer
  const INSIGHTS_ENABLED = false;

  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('openCookieSettings'));
  };

  return (
    <footer className="bg-brand-purple text-brand-lightblue">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-6">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753184535398-white_transparent.png"
                alt="Trbe Logo"
                className="h-8"
              />
            </div>
            <p className="text-brand-lightblue mb-6 max-w-md">
              We help robotics and AI companies find the people who build the future — not just great engineers, but great teammates.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="h-4 w-4" />
                <span>hello@trbe.ai</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="h-4 w-4" />
                <span>+49 (0) 30 1234 5678</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMapPin} className="h-4 w-4" />
                <span>Berlin, Germany</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services" className="hover:text-white transition-colors">Recruitment</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">HR Consulting</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Team Development</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Executive Search</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/candidates" className="hover:text-white transition-colors">For Candidates</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              {INSIGHTS_ENABLED && (
                <li><Link to="/insights" className="hover:text-white transition-colors">Insights</Link></li>
              )}
              <li><Link to="/imprint" className="hover:text-white transition-colors">Imprint</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Datenschutz</Link></li>
              <li><Link to="/cookies" className="hover:text-white transition-colors">Cookie Policy</Link></li>
              <li>
                <button
                  onClick={openCookieSettings}
                  className="flex items-center space-x-1 hover:text-white transition-colors"
                >
                  <SafeIcon icon={FiSettings} className="h-3 w-3" />
                  <span>Cookie Settings</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-lightblue border-opacity-20 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-brand-lightblue text-sm">
            © 2024 Trbe. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 sm:mt-0">
            <a href="#" className="text-brand-lightblue hover:text-white transition-colors">
              <SafeIcon icon={FiLinkedin} className="h-5 w-5" />
            </a>
            <a href="#" className="text-brand-lightblue hover:text-white transition-colors">
              <SafeIcon icon={FiTwitter} className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
